<template>
    <div class="flex flex-row">
        <!-- PC端显示 -->
        <div v-if="!isSmallScreen" class="flex h-screen w-full">
            <transition name="sidebar-width">
                <aside :class="['chat-sidebar', { 'sidebar-expanded': isExpanded }]" class="bg-gray-200 ">
                    <div class="flex flex-col p-2 mt-4">
                        <div v-if="isExpanded" class="flex items-center  justify-between ">
                            <span class="pl-5 ">识心智能</span>
                            <svg class="w-10 h-10 cursor-pointer" @click="toggleSidebar" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><clipPath id="clip1382_20239"><rect id="折叠边栏0730" width="30.000000" height="30.000000" fill="white" fill-opacity="0"></rect></clipPath></defs><rect id="折叠边栏0730" width="30.000000" height="30.000000" fill="#FFFFFF" fill-opacity="0"></rect><g clip-path="url(#clip1382_20239)"><rect id="rect" x="17.420410" y="12.316406" rx="1.000947" width="5.995172" height="2.001895" transform="rotate(137.159 17.420410 12.316406)" fill="currentColor" fill-opacity="1.000000"></rect><rect id="rect" x="12.959473" y="13.728516" rx="0.995190" width="6.002943" height="1.990380" transform="rotate(40.853 12.959473 13.728516)" fill="currentColor" fill-opacity="1.000000"></rect><path id="path" d="M20.1 25.5L9.9 25.51C9.48 25.51 9.06 25.47 8.65 25.39C8.24 25.3 7.84 25.18 7.45 25.02C7.06 24.86 6.69 24.66 6.34 24.43C5.99 24.19 5.67 23.92 5.37 23.63C5.07 23.33 4.81 23 4.58 22.65C4.34 22.3 4.15 21.93 3.98 21.54C3.82 21.15 3.7 20.75 3.62 20.34C3.54 19.93 3.5 19.51 3.5 19.09L3.5 10.93C3.5 10.51 3.54 10.1 3.62 9.68C3.7 9.27 3.82 8.87 3.98 8.48C4.15 8.09 4.34 7.72 4.58 7.37C4.81 7.02 5.07 6.69 5.37 6.39C5.67 6.1 5.99 5.83 6.34 5.6C6.69 5.36 7.06 5.16 7.45 5C7.84 4.84 8.24 4.72 8.65 4.64C9.06 4.55 9.48 4.51 9.9 4.51L20.1 4.5C20.52 4.5 20.94 4.54 21.35 4.62C21.76 4.7 22.16 4.83 22.55 4.99C22.94 5.15 23.31 5.35 23.66 5.58C24 5.82 24.33 6.08 24.62 6.38C24.92 6.68 25.19 7 25.42 7.35C25.65 7.7 25.85 8.07 26.01 8.46C26.17 8.85 26.3 9.25 26.38 9.67C26.46 10.08 26.5 10.5 26.5 10.92L26.5 19.07C26.5 19.5 26.46 19.91 26.38 20.32C26.3 20.74 26.17 21.14 26.01 21.53C25.85 21.92 25.65 22.29 25.42 22.64C25.19 22.99 24.92 23.31 24.62 23.61C24.33 23.91 24 24.17 23.66 24.41C23.31 24.64 22.94 24.84 22.55 25C22.16 25.16 21.76 25.29 21.35 25.37C20.94 25.45 20.52 25.5 20.1 25.5ZM9.9 6.6C9.61 6.6 9.33 6.63 9.05 6.69C8.78 6.74 8.51 6.82 8.24 6.93C7.98 7.04 7.73 7.18 7.5 7.33C7.26 7.49 7.04 7.67 6.84 7.87C6.64 8.07 6.46 8.29 6.31 8.53C6.15 8.77 6.02 9.01 5.91 9.28C5.8 9.54 5.72 9.81 5.66 10.09C5.61 10.37 5.58 10.65 5.58 10.93L5.58 19.09C5.58 19.37 5.61 19.65 5.66 19.93C5.72 20.21 5.8 20.48 5.91 20.74C6.02 21.01 6.15 21.26 6.31 21.49C6.46 21.73 6.64 21.95 6.84 22.15C7.04 22.35 7.26 22.53 7.5 22.69C7.73 22.85 7.98 22.98 8.24 23.09C8.51 23.2 8.78 23.28 9.05 23.33C9.33 23.39 9.61 23.42 9.9 23.42L20.1 23.41C20.38 23.41 20.67 23.37 20.94 23.32C21.22 23.26 21.49 23.18 21.75 23.07C22.01 22.96 22.26 22.83 22.5 22.67C22.73 22.51 22.95 22.33 23.15 22.13C23.35 21.93 23.53 21.71 23.69 21.48C23.85 21.24 23.98 20.99 24.09 20.73C24.2 20.47 24.28 20.2 24.33 19.92C24.39 19.64 24.42 19.36 24.42 19.07L24.42 10.92C24.42 10.64 24.39 10.35 24.33 10.07C24.28 9.79 24.2 9.52 24.09 9.26C23.98 9 23.85 8.75 23.69 8.51C23.53 8.28 23.35 8.06 23.15 7.86C22.95 7.66 22.73 7.48 22.5 7.32C22.26 7.16 22.01 7.03 21.75 6.92C21.49 6.81 21.22 6.73 20.94 6.67C20.67 6.62 20.38 6.59 20.1 6.59L9.9 6.6Z" fill="currentColor" fill-opacity="1.000000" fill-rule="nonzero"></path><path id="rect" d="M8.5 5.51L10.54 5.51L10.6 24.43L8.55 24.43L8.5 5.51Z" fill="currentColor" fill-opacity="1.000000" fill-rule="evenodd"></path></g></svg>
                        </div>
                        <div v-else class="flex items-center ml-2 ">
                            <div class="flex flex-col gap-8">
                                <!-- Logo -->
                                <el-tooltip content="展开/收起侧边栏" placement="right" effect="light">
                                    <img @click="toggleSidebar"
                                         src="@/assets/logo.png"
                                         alt="Logo" 
                                        class="max-w-full max-h-full -ml-1 object-contain cursor-pointer hover-scale transform scale-125 origin-center" />
                                </el-tooltip>

                                <!-- 返回按钮 -->
                                <el-tooltip content="返回模拟列表" placement="right" effect="light">
                                    <svg @click="backToList"
                                         class="w-10 h-10 cursor-pointer text-gray-600 hover:text-gray-800"
                                         viewBox="0 0 24 24"
                                         fill="none"
                                         stroke="currentColor"
                                         stroke-width="2"
                                         stroke-linecap="round"
                                         stroke-linejoin="round">
                                        <path d="M19 12H5M12 19l-7-7 7-7" />
                                    </svg>
                                </el-tooltip>

                                <!-- 新对话按钮 -->
                                <el-tooltip content="开启新对话" placement="right" effect="light">
                                    <svg @click="newChat"
                                         class="w-10 h-10 cursor-pointer"
                                         viewBox="0 0 30 30"
                                         fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                        <g clip-path="url(#clip1325_20400)"><path id="path" d="M10.51 26.52C10.35 26.52 10.19 26.49 10.04 26.43C9.89 26.37 9.76 26.28 9.64 26.17C9.53 26.06 9.44 25.93 9.37 25.78C9.31 25.63 9.28 25.48 9.28 25.32L9.25 22.87C8.89 22.82 8.53 22.74 8.19 22.62C7.84 22.5 7.51 22.36 7.19 22.19C6.86 22.01 6.56 21.81 6.28 21.58C5.99 21.36 5.73 21.11 5.49 20.83C5.25 20.56 5.04 20.27 4.85 19.96C4.67 19.65 4.51 19.33 4.38 18.99C4.25 18.65 4.16 18.3 4.09 17.95C4.03 17.6 4 17.24 4 16.88L4 10.38C4 9.99 4.03 9.6 4.11 9.21C4.19 8.82 4.31 8.45 4.46 8.08C4.61 7.72 4.8 7.37 5.03 7.04C5.25 6.72 5.5 6.41 5.78 6.13C6.07 5.86 6.38 5.61 6.71 5.39C7.04 5.17 7.4 4.98 7.77 4.83C8.14 4.68 8.52 4.57 8.91 4.49C9.31 4.41 9.7 4.38 10.11 4.38L14.35 4.38C14.5 4.38 14.63 4.4 14.77 4.46C14.9 4.51 15.02 4.59 15.12 4.69C15.22 4.79 15.3 4.9 15.35 5.03C15.41 5.16 15.43 5.3 15.43 5.44C15.43 5.58 15.41 5.71 15.35 5.84C15.3 5.97 15.22 6.09 15.12 6.19C15.02 6.29 14.9 6.37 14.77 6.42C14.63 6.47 14.5 6.5 14.35 6.5L10.11 6.5C9.85 6.5 9.59 6.53 9.34 6.58C9.08 6.62 8.83 6.7 8.6 6.8C8.36 6.89 8.13 7.01 7.91 7.15C7.7 7.3 7.5 7.46 7.31 7.64C7.13 7.82 6.97 8.01 6.82 8.22C6.68 8.44 6.56 8.66 6.46 8.9C6.36 9.13 6.28 9.37 6.23 9.62C6.18 9.87 6.16 10.12 6.16 10.38L6.16 16.88C6.16 17.14 6.18 17.39 6.23 17.65C6.29 17.9 6.36 18.15 6.46 18.39C6.56 18.62 6.69 18.85 6.83 19.07C6.98 19.28 7.15 19.48 7.33 19.66C7.52 19.85 7.72 20.01 7.94 20.15C8.16 20.3 8.39 20.42 8.63 20.52C8.87 20.62 9.13 20.69 9.38 20.74C9.64 20.79 9.9 20.82 10.17 20.82C10.33 20.82 10.49 20.85 10.64 20.91C10.79 20.97 10.92 21.06 11.04 21.17C11.15 21.28 11.24 21.41 11.31 21.56C11.37 21.71 11.4 21.86 11.41 22.02L11.42 23.53L14.15 21.56C14.85 21.07 15.62 20.82 16.48 20.82L19.87 20.82C20.13 20.82 20.38 20.79 20.64 20.74C20.89 20.69 21.14 20.62 21.38 20.52C21.62 20.42 21.85 20.3 22.06 20.16C22.28 20.02 22.48 19.86 22.66 19.68C22.84 19.5 23.01 19.3 23.15 19.09C23.29 18.88 23.42 18.66 23.52 18.42C23.61 18.19 23.69 17.94 23.74 17.69C23.79 17.44 23.82 17.19 23.82 16.94L23.82 13.58C23.82 13.44 23.84 13.3 23.9 13.17C23.95 13.04 24.03 12.93 24.13 12.83C24.23 12.73 24.35 12.65 24.48 12.6C24.62 12.54 24.75 12.52 24.9 12.52C25.04 12.52 25.18 12.54 25.31 12.6C25.44 12.65 25.56 12.73 25.66 12.83C25.76 12.93 25.84 13.04 25.9 13.17C25.95 13.3 25.98 13.44 25.98 13.58L25.98 16.94C25.98 17.33 25.94 17.72 25.86 18.11C25.78 18.5 25.67 18.87 25.51 19.24C25.36 19.6 25.17 19.95 24.95 20.27C24.73 20.6 24.47 20.9 24.19 21.18C23.9 21.46 23.6 21.71 23.26 21.93C22.93 22.15 22.58 22.33 22.21 22.48C21.83 22.63 21.45 22.75 21.06 22.83C20.67 22.9 20.27 22.94 19.87 22.94L17.19 22.94C16.33 22.94 15.56 23.19 14.86 23.69L11.24 26.29C11.02 26.44 10.78 26.52 10.51 26.52Z" fill="currentColor" fill-opacity="1.000000" fill-rule="nonzero"></path><rect id="rect" x="17.770508" y="6.396484" rx="1.062250" width="8.060087" height="2.124500" fill="currentColor" fill-opacity="1.000000"></rect><rect id="rect" x="20.718750" y="3.500000" rx="1.081197" width="2.162393" height="7.918844" fill="currentColor" fill-opacity="1.000000"></rect></g>
                                    </svg>
                                </el-tooltip>

                            </div>
                        </div>

                        <div v-if="isExpanded" class="transition-opacity duration-200">
                            <div class="rounded-lg bg-blue-500 p-2 max-w-max max-h-max cursor-pointer hover:bg-blue-600 mt-2">
                                <i class="fas fa-plus ml-2 mr-2 text-white"></i>
                                <span class="mr-2 text-white">开启新的对话</span>
                            </div>

                            <div class="h-[calc(100vh-240px)] overflow-hidden overflow-y-auto mt-4">
                                <div v-for="(itemlist, index) in historyList" :key="index">
                                    <div class="mt-4">
                                        <span class="text-gray-600 font-bold text-2xl">{{formatDayInfo(itemlist.date)}}</span>
                                    </div>
                                    <ul class="mt-2">
                                        <li v-for="(item, index2) in itemlist.list" :key="index2">
                                            <div class="relative p-2 items-center justify-between rounded-lg cursor-pointer hover:bg-gray-300"
                                                 :class="curHistoryIndex && curHistoryIndex[0] === index && curHistoryIndex[1] === index2 ? 'bg-gray-300' : ''"
                                                 @click="selectShowHistory(index,index2)">
                                                <div class="flex group">
                                                    <span class="w-40 whitespace-nowrap overflow-hidden text-ellipsis">{{item.tipInfo}}</span>
                                                    <i @click.stop @click="toggleDropdown(index,index2)"
                                                       :class="curHistoryIndex && curHistoryIndex[0] === index && curHistoryIndex[1] === index2 ? 'opacity-100' : ''"
                                                       class="fas p-2 fa-ellipsis-h hover:bg-gray-400 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity"></i>
                                                    <div v-show="curSelectIndex && curSelectIndex.length > 0 && historyList[curSelectIndex[0]] && historyList[curSelectIndex[0]].list[curSelectIndex[1]].showMore"
                                                         class="action-menu fixed bg-white shadow-md py-1 mt-2 w-32 rounded-lg"
                                                         :style="{ top: dropdownPosition.top + 'px', left: dropdownPosition.left + 'px' }"
                                                         @click.stop>
                                                        <a href="#" class="block px-4 py-2 text-gray-700 hover:bg-gray-200 rounded-lg" @click.prevent="renameHistory">
                                                            <i class="fas fa-pen mr-2"></i> 重命名
                                                        </a>
                                                        <a href="#" class="block px-4 py-2 text-gray-700 hover:bg-gray-200 rounded-lg" @click.prevent="deleteHistory">
                                                            <i class="fas fa-trash mr-2"></i> 删除
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </aside>
            </transition>
            <div class="talk-window w-full">
                <div class="talk-title">
                    <p>{{ answerTitle }}</p>
                </div>
                <div class="talk-container bg-gray-500">
                    <div class="talk-welcome" v-if="contentList && contentList.length == 0">
                        <h1>{{ welcome.title }}</h1>
                        <p class="text-left">{{ welcome.desc }}</p>
                    </div>

                    <!--:style="{ height: answerContHeight+'px'}"  :class="contentList.length === 0? '' : ' sticky bottom-0'"-->
                    <div v-else>
                        <div class="character-info fixed bg-white shadow-lg rounded-lg p-4 m-4 z-10">
                            <div class="flex items-center gap-2">
                                <!--                        <img :src="curChatCharacter.avatar || require('@/assets/pic4.png')"
                            class="w-10 h-10 rounded-full" />-->
                                <div>
                                    <h3 class="font-bold text-gray-800">{{ curChatCharacter ? curChatCharacter.name:"" }}</h3>
                                    <img :src="this.welcome.icon" /><!-- TODO 可能有问题-->
                                    <p class="text-sm  font-bold mt-2 text-gray-600">{{ curChatCharacter? curChatCharacter.description:"" }}</p>
                                </div>
                            </div>
                        </div>
                        <div class="right-showSummary  mt-2 fixed right-2">
                            <el-button type="primary" @click="SummaryCheck">{{curSumStatus ? "查看总结":"生成总结"}}</el-button>
                        </div>
                        <div class="talk-box overflow-y-auto scrollable h-screen  bg-gray-500" :style="{ height: answerContHeight+'px'}" ref="talkBox">
                            <div ref="logContainer" class="talk-content overflow-y-auto scrollable ">
                                <el-row v-for="(item, i) in contentList" :key="i" class="chat-assistant">
                                    <transition name="fade">
                                        <div :class="['answer-cont', item.type === 'send' ? 'end' : 'start']">
                                            <img v-if="item.type == 'answer'" :src="welcome.icon" />
                                            <div :class="item.type === 'send' ? 'send-item' : 'answer-item'">
                                                <div v-if="item.type == 'answer'" class="hashrate-markdown" v-html="item.message" />
                                                <div v-else>{{ item.message }}</div>
                                            </div>
                                        </div>
                                    </transition>
                                </el-row>
                            </div>
                        </div>
                    </div>
                    <div class="talk-send mb-2" :class="{ 'bottom-2 absolute w-3/5 ': contentList && contentList.length > 0 }">
                        <textarea @keydown.enter="enterMessage"
                                  ref="input"
                                  v-model="inputMessage"
                                  @input="adjustInputHeight"
                                  placeholder="输入消息..." />
                        <div class="talk-btn-cont flex justify-end gap-2">
                            <!--停止-->
                            <div class="flex items-center justify-center w-10 h-10 rounded-full  bg-gray-300 -mt-2">
                                <i @click="endTalkSummarize" class="fas fa-stop text-2xl text-gray-600  text-center "
                                   :class="{ 'text-purple-500': contentList && contentList.length > 1 }"></i>
                            </div>
                            <!--发送箭头-->
                            <svg :class="{'bg-purple-500 text-white cursor-pointer': inputMessage && inputMessage.length > 0,'bg-gray-300 text-gray-500 ': inputMessage && inputMessage.length === 0}"
                                 class="h-10 w-10  rounded-full p-2 -mt-2" @click="sendMessage"
                                 viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M7 16c-.595 0-1.077-.462-1.077-1.032V1.032C5.923.462 6.405 0 7 0s1.077.462 1.077 1.032v13.936C8.077 15.538 7.595 16 7 16z" fill="currentColor"></path>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M.315 7.44a1.002 1.002 0 0 1 0-1.46L6.238.302a1.11 1.11 0 0 1 1.523 0c.421.403.421 1.057 0 1.46L1.838 7.44a1.11 1.11 0 0 1-1.523 0z" fill="currentColor"></path>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M13.685 7.44a1.11 1.11 0 0 1-1.523 0L6.238 1.762a1.002 1.002 0 0 1 0-1.46 1.11 1.11 0 0 1 1.523 0l5.924 5.678c.42.403.42 1.056 0 1.46z" fill="currentColor"></path>
                            </svg>
                        </div>
                    </div>
                </div>


                <!--<taskDialog v-if="isShowTask" :choicedTasks="choicedTasks" v-model:isShow="isShowTask" @confirm="confirmTask" />-->
            </div>
        </div>
        
        <!-- 移动端显示 -->
        <template v-if="isSmallScreen">
            <div class="mobile-sidebar bg-gray-200 w-full" v-if="isExpanded">
                <div class="flex flex-row justify-between items-center p-4 border-b border-gray-300">
                    <span class="text-lg font-semibold">识心智能</span>
                    <svg class="w-8 h-8 cursor-pointer" @click="toggleSidebar" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <line x1="18" y1="6" x2="6" y2="18"></line>
                        <line x1="6" y1="6" x2="18" y2="18"></line>
                    </svg>
                </div>
                
                <div class="p-4">
                    <div class="flex flex-row justify-start gap-2">
                        <div class="rounded-lg bg-blue-500 p-2 flex flex-row items-center justify-center cursor-pointer hover:bg-blue-600 mb-4">
                            <i class="fas fa-plus mr-2 text-white"></i>
                            <span class="text-white">新的对话</span>
                        </div>

                        <div class="rounded-lg bg-blue-500 p-2 flex flex-row items-center justify-center cursor-pointer hover:bg-blue-600 mb-4">
                            <svg class="w-5 h-5 mr-2 text-white" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M19 12H5M12 19l-7-7 7-7" />
                            </svg>
                            <span class="text-white">返回列表</span>
                        </div>

                    </div>
                    
                    <div class="h-[calc(100vh-200px)] overflow-y-auto">
                        <div v-for="(itemlist, index) in historyList" :key="index">
                            <div class="mt-4">
                                <span class="text-gray-600 font-bold text-xl">{{formatDayInfo(itemlist.date)}}</span>
                            </div>
                            <ul class="mt-2">
                                <li v-for="(item, index2) in itemlist.list" :key="index2">
                                    <div class="relative p-3 flex flex-row items-left justify-between rounded-lg cursor-pointer hover:bg-gray-300"
                                         :class="curHistoryIndex && curHistoryIndex[0] === index && curHistoryIndex[1] === index2 ? 'bg-gray-300' : ''"
                                         @click="selectShowHistory(index,index2)">
                                        <span class="flex-1 whitespace-nowrap overflow-hidden text-ellipsis">{{item.tipInfo}}</span>
                                        <i @click.stop @click="toggleDropdown(index,index2)"
                                           class="fas p-2 fa-ellipsis-h hover:bg-gray-400 rounded-lg"></i>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="talk-window w-full" v-if="!isExpanded">
                <div class="talk-title flex flex-row items-center justify-between p-2">
                    <svg @click="toggleSidebar" class="w-6 h-6 cursor-pointer" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <line x1="3" y1="12" x2="21" y2="12"></line>
                        <line x1="3" y1="6" x2="21" y2="6"></line>
                        <line x1="3" y1="18" x2="21" y2="18"></line>
                    </svg>
                    <p class="flex-1 text-center">{{ answerTitle }}</p>
                    <div class="w-6"></div> 
                </div>
                <div class="talk-container bg-gray-500">
                    <div class="talk-welcome" v-if="contentList && contentList.length == 0">
                        <h1>{{ welcome.title }}</h1>
                        <p class="text-left">{{ welcome.desc }}</p>
                    </div>

                    <div v-else>
                        <div class="character-info fixed bg-white shadow-lg rounded-lg p-3 mx-auto left-0 right-0 text-center top-2 z-10 max-w-[90%] w-fit">
                            <div class="flex items-center gap-2 flex-row">
                                <h3 class="font-bold text-gray-800 text-sm">{{ curChatCharacter ? curChatCharacter.name:"" }}</h3>
                                <p class="text-xs font-bold mt-1 text-gray-600">{{ curChatCharacter ? curChatCharacter.description:"" }}</p>
                            </div>
                        </div>

                        <div class="talk-box overflow-y-auto scrollable h-screen w-screen bg-gray-500 pt-20" :style="{ height: answerContHeight+'px'}" ref="talkBox">
                            <div ref="logContainer" class="talk-content overflow-y-auto scrollable px-2 pb-16">
                                <el-row v-for="(item, i) in contentList" :key="i" class="chat-assistant">
                                    <transition name="fade">
                                        <div :class="['answer-cont', item.type === 'send' ? 'end' : 'start']">
                                            <img v-if="item.type == 'answer'" :src="welcome.icon" class="w-6 h-6" />
                                            <div :class="item.type === 'send' ? 'send-item' : 'answer-item'" class="text-sm">
                                                <div v-if="item.type == 'answer'" class="hashrate-markdown" v-html="item.message" />
                                                <div v-else>{{ item.message }}</div>
                                            </div>
                                        </div>
                                    </transition>
                                </el-row>
                            </div>
                        </div>
                    </div>
                    <div class="talk-send px-2 fixed bottom-0 left-0 right-0 bg-gray-100 border-t border-gray-300 py-2 z-20">
                        <textarea @keydown.enter="enterMessage"
                                  ref="input"
                                  v-model="inputMessage"
                                  @input="adjustInputHeight"
                                  placeholder="输入消息..." 
                                  class="text-sm" />
                        <div class="talk-btn-cont flex justify-end space-x-2 flex-row">
                                <i v-if="!curSumStatus" @click="endTalkSummarize"
                                   class="fas fa-stop p-2 bg-gray-300 rounded-full text-gray-600 text-center"
                                   :class="{ 'text-purple-500': contentList && contentList.length > 1 }"></i>
                                <div  v-else class="text-white bg-blue-500 rounded-lg" @click="SummaryCheck">查看总结</div>
                            <svg :class="{'bg-purple-500 text-white cursor-pointer': inputMessage && inputMessage.length > 0,'bg-gray-300 text-gray-500 ': inputMessage && inputMessage.length === 0}"
                                 class="h-8 w-8 rounded-full p-2" @click="sendMessage"
                                 viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M7 16c-.595 0-1.077-.462-1.077-1.032V1.032C5.923.462 6.405 0 7 0s1.077.462 1.077 1.032v13.936C8.077 15.538 7.595 16 7 16z" fill="currentColor"></path>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M.315 7.44a1.002 1.002 0 0 1 0-1.46L6.238.302a1.11 1.11 0 0 1 1.523 0c.421.403.421 1.057 0 1.46L1.838 7.44a1.11 1.11 0 0 1-1.523 0z" fill="currentColor"></path>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M13.685 7.44a1.11 1.11 0 0 1-1.523 0L6.238 1.762a1.002 1.002 0 0 1 0-1.46 1.11 1.11 0 0 1 1.523 0l5.924 5.678c.42.403.42 1.056 0 1.46z" fill="currentColor"></path>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
        </template>

        <!-- PC端对话框 -->
        <el-dialog title="总结报告" top="30px" :visible.sync="isSummaryVisible" width="600px" v-if="!isSmallScreen" @close="hideSummary()">
            <div class="p-2">
                <div class="hashrate-markdown" v-html="summaryShowInfo" />
            </div>
        </el-dialog>
        
        <!-- 移动端对话框 -->
        <el-dialog title="总结报告" top="30px" :visible.sync="isSummaryVisible" width="90%" v-else @close="hideSummary()">
            <div class="p-2">
                <div class="hashrate-markdown text-sm" v-html="summaryShowInfo" />
            </div>
        </el-dialog>
    </div>
</template>

<script>
    /*import taskDialog from '@/views/chat/task/taskDialog.vue'
    import copyrightContent from '@/views/chat/talking/components/copyright.vue'*/
    import hljs from 'highlight.js'
    /*import 'highlight.js/styles/a11y-dark.css'*/
    import MarkdownIt from 'markdown-it'
    import { fetchEventSource } from '@microsoft/fetch-event-source';
    
    import { jwtDecode } from 'jwt-decode';
    import axios from 'axios';
    import { mapState } from 'vuex';

window.hiddenThink = function (index) {
  // 隐藏思考内容
  if (document.getElementById(`think_content_${index}`).style.display == 'none') {
    document.getElementById(`think_content_${index}`).style.display = 'block'
    document.getElementById(`think_icon_${index}`).classList.replace('icon-a-xiangshang3', 'icon-a-xiangxia3')
  } else {
    document.getElementById(`think_content_${index}`).style.display = 'none'
    document.getElementById(`think_icon_${index}`).classList.replace('icon-a-xiangxia3', 'icon-a-xiangshang3')
  }
}

    import { mapActions } from 'vuex'
export default {

  props: {
    isCollapsed: {
      type: Boolean,
      default: false
    },
    activeChat: String,
    activeTitle: String,
    chat_style_setting: {
      type: Object,
      default: function () {
        return {}
      }
    },
    systemNameOption: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data() {
      return {
          isSmallScreen: false,
        isSending:false,
        isSummaryVisible:false,
        dropdownPosition: {
            top: 0,
            left: 0
        },
        curChatCharacter: null,
        summaryShowInfo: null,
        curSumStatus: false,
        curUserId:null,
        curHistoryIndex: [-1, -1],
        curSelectIndex: [],
        curConversation_id:null,
        curSummary_id: null,
        ansDisplayBuffer:'',
        typingInterval: null,          
        historyList: [
            {//todo  del
                date: "2025-04-17",
                list: [
                    { tipInfo: "2025-04-17", showMore: false },
                    { tipInfo: "bbbbbbbbbbbbbbbbnnnnnnnnnnnn", showMore: false ,queryHistory:[{type: 'send', message: "hello?"},{type: 'answer', message: "hi!"},{type: 'send', message: "how are your?"},{type: 'answer', message: "naota!"},]},
                ]
            },
        ],
            
      isExpanded: false,
      inputMessage: '',
      messages: [],
      choicedTasks: {
        uuid: '1',
        name: 'base'
      },
      isShowTask: false,
      contentList: [],
      eventSourceChat: null,
      markdownIt: {},
      startAnwer: false,
      startTime: null,
      endTime: null,
      thinkTime: null,
      answerTitle: '',
      talkUUID: '',
      refreshHistoryFlag: false, // 是否已经生成了对话uuid,生成了的话就刷新历史列表
      msgHight: null,
      isTalking: false, //是否在对话中,处于对话中则展示休止按钮
      welcome: {
        title: '很高兴见到你！',
        desc: '角色模型加载失败，请返回官网重新登录。',
        icon: require('@/assets/pic4.png')
      },
      store: {}
    }
  },
  watch: {
    activeTitle(val) {
      // 重命名了对话
      this.answerTitle = val
    },
    activeChat(val) {
      this.answerTitle = ''
      this.talkUUID = val || ''
      this.inputMessage = ''
      this.refreshHistoryFlag = false
      this.isTalking = false
      if (val) {
        // 滚动回到顶部
        const logContainer = this.$refs.logContainer
        if (logContainer) {
          logContainer.scrollTop = 0
        }
        this.getTalkDetail()
      } else {
        this.contentList = []
      }
      this.eventSourceChat && this.eventSourceChat.close()
    },
    chat_style_setting(val) {
      this.welcome.title = val.welcome_speech_style || this.welcome.title
      this.welcome.desc = val.description_style || this.welcome.desc
      this.welcome.icon = val.icon_image || this.welcome.icon
    }
  },
    computed: {
        ...mapState({
            globalCharacters: state => state.globalCharacters
        }),
        sidebarClass() {
            return this.isExpanded ? 'w-40' : 'w-15'; // 24px when expanded, 5px when collapsed
        },
        answerContHeight() {
            // 根据屏幕尺寸和消息高度计算对话框高度
            if (this.isSmallScreen) {
                // 移动端高度计算
                return this.msgHight == '56px' ? 'calc(100vh - 120px)' : `calc(100vh - 120px - ${this.msgHight} + 56px)`
            } else {
                // PC端高度计算
                return this.msgHight == '56px' ? 'calc(100vh - 140px)' : `calc(100vh - 140px - ${this.msgHight} + 56px)`
            }
        }
        },

  mounted() {
    //this.store = mainStore()
      // 检查屏幕尺寸并设置isSmallScreen
      this.checkScreenSize();
      window.addEventListener('resize', this.checkScreenSize);
      
    this.markdownIt = MarkdownIt({
      html: true,
      linkify: true,
      highlight: function (str, lang) {
        if (lang && hljs.getLanguage(lang)) {
          try {
            return hljs.highlight(str, { language: lang }).value
          } catch (__) {
                console.log("1");
          }
        }
        return '' // use external default escaping
        }
    })

      document.addEventListener("click", this.handleClickOutside);
    },
        methods: {
            checkScreenSize() {
                this.isSmallScreen = window.innerWidth < 768;
            },
            hideSummary() {
                this.isSummaryVisible = false;
            },
            SummaryCheck() {
                if (!this.curSumStatus) {
                    this.endTalkSummarize();
                } else {
                    this.isSummaryVisible = true;
                }
            },
            ...mapActions(['fetchGlobalCharacters']),
            async fetchCharacters() {
                await this.fetchGlobalCharacters()
            },
            async getConversationInfo(conversation_id, user) {
                console.log("11111222");
                const headers = {
                    "Authorization": `Bearer ${this.curChatCharacter.api_key}`,
                };
                const baseUrl = "/xing-api/v1/messages";
                let allMessages = [];

                // 内部递归函数处理分页
                const fetchMessages = async (cursor = null) => {
                    const params = {
                        "user": user || "abc-123",
                        "conversation_id": conversation_id,
                        "limit": "40",
                        ...(cursor && { cursor: cursor }) // 只在有cursor时添加此参数
                    };

                    try {
                        const response = await axios.get(baseUrl, { headers, params });

                        if (response.status === 200) {
                            // 处理当前页的消息
                            const currentMessages = [];
                            for (const info of response.data.data) {
                                if (info.query) {
                                    currentMessages.push({ type: 'send', message: info.query });
                                }
                                if (info.answer) {
                                    currentMessages.push({ type: 'answer', message: info.answer });
                                }
                            }

                            allMessages = [...allMessages, ...currentMessages];
                            if (response.data.has_more) {
                                await fetchMessages();
                            }
                        }
                    } catch (error) {
                        console.error('获取对话信息失败:', error);
                        throw error; // 向上传递错误
                    }
                };
                try {
                    // 开始获取所有消息
                    await fetchMessages();
                    if (allMessages.length > 0) {
                        this.contentList = allMessages;
                        this.$nextTick(() => {
                            this.scrollToBottomIfAtBottom();
                        });
                    }                    
                    return allMessages; // 返回所有消息
                } catch (error) {
                    console.error('处理对话信息失败:', error);
                    this.$message({
                        message: '获取对话历史失败,请稍后重试',
                        type: 'error'
                    });
                }
            },
            convertReturnList(originalData) {
                const dateMap = new Map();

                console.log("item.startTime");

                console.log(originalData);
                originalData.forEach(item => {
                        const timestamp = parseInt(item.startTime);
                        const date = new Date(timestamp).toISOString().split('T')[0];
                        if (!dateMap.has(date)) {
                            dateMap.set(date, []);
                        }
                        const newItem = {
                            tipInfo: item.tipInfo,
                            showMore: false,
                            characterId: item.characterId,
                            id: item.id,
                            conversation_id: item.conversation_id,
                            summary: item.summary,
                            trainType: item.trainType,
                            summaryTime: item.summaryTime,
                        };
                        dateMap.get(date).push(newItem);
                    });
                const historyList = Array.from(dateMap.entries()).map(([date, list]) => ({ date, list }));
                return historyList;
            },
            async getHistoryTalk() {
                const token = localStorage.getItem('token');
                try {
                    const response = await axios({
                        method: 'get',
                        //url: `/api/train/history?page=${page}`,
                        url: "/api/train/history?page=0",
                        headers: {
                            'accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`
                        },
                    });
                    if (response.status !== 200) {
                        console.error('Failed to update no 200:');
                        console.error(response.data);
                    } else if (response.data.code == "00") {
                        if (this.historyList)this.historyList.splice(0, this.historyList.length);
                        this.historyList = this.convertReturnList(response.data.talkList);
                    } else {
                        this.$message({message: response.data.message,type: 'error'});
                    }
                } catch (error) {
                    console.error('Failed to update:', error);
                    this.$message({
                        message: '网络异常，请稍后重试',
                        type: 'error'
                    });
                }
            },
            async updateConversation() {//上送服务器
                const token = localStorage.getItem('token');
                let startTime = new Date().getTime();
                //this.curSummary_id = "sum_" + String(this.curChatCharacter.id) + startTime;
                
                const requestData = {
                    trainType: "long",
                    characterId: this.curChatCharacter.id,
                    conversation_id: this.curConversation_id,
                    startTime: startTime,
                    client_id: this.curSummary_id,
                    tipInfo: this.answerTitle, 
                };
                try {
                    const response = await axios({
                        method: 'post',
                        url: '/api/train/update',
                        headers: {
                            'accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`
                        },
                        data: requestData
                    });
                    if (response.status !== 200) {
                        console.error('Failed to update no 200:');
                        console.error(response.data);
                    }
                } catch (error) {
                    console.error('Failed to update:', error);
                    this.$message({
                        message: '网络异常，请稍后重试',
                        type: 'error'
                    });
                }
            },
            async endTalkSummarize() {
                if (this.contentList.length <= 1) {
                    return false;
                }
                if (this.isSending) {
                    return false;
                }
                this.isSending = true;
                const token = localStorage.getItem('token');
                try {
                    const history = this.convertHistory();
                    const requestData = {
                        summary_id: this.curSummary_id,
                        history: history,
                        conversation_id: this.curConversation_id,
                        baseurl:this.curChatCharacter.baseurl,
                        client_ID: this.curChatCharacter.client_ID,
                        api_key: this.curChatCharacter.api_key,
                    };
                    this.$message({
                        message: '总结生成需要1-2分钟，请稍后查看。',
                        type: 'success'
                    });
                    const response = await axios({
                        method: 'post',
                        timeout: 160*1000,
                        url: '/api/train/make_summary',
                        headers: {
                            'accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`
                        },
                        data: requestData
                    });

                    if (response.status === 200) {
                        console.log('Summary created successfully:', response.data);
                        if (response.data.summary) {
                            this.$message({
                                message: '对话总结已生成，请查看。',
                                type: 'success'
                            });
                            this.summaryShowInfo = response.data.summary;
                            this.curSumStatus=true;
                            return true;
                        }
                    } else {
                        this.$message({
                            message: '生成总结失败，请稍后重试',
                            type: 'error'
                        });
                        return false;
                    }
                } catch (error) {
                    console.error('Failed to create summary:', error);
                    this.$message({
                        message: '生成总结失败，请稍后重试',
                        type: 'error'
                    });
                    return false;
                } finally {
                    this.isSending = false;
                }
            },

            convertHistory() {
                var result = '';
                this.contentList.forEach(item => {
                    if (item.type === 'send') {
                        result += `query: ${item.message}\n `;
                    } else if (item.type === 'answer') {
                        let answer = item.message.replace(/<[^>]*>/g, '');
                        answer = answer.replace(/&nbsp;/g, ' ')
                            .replace(/&lt;/g, '<')
                            .replace(/&gt;/g, '>')
                            .replace(/&amp;/g, '&')
                            .replace(/&quot;/g, '"');
                        result += `answer: ${answer}\n `;
                    }
                });
                return result.trim(); 
            },
            getAvatar(character) {
                if (!character || !character.name) {
                    return require('@/assets/logo.png');
                }
                return `/api/resource/get?type=talk&filename=${encodeURIComponent(character.name + ".png")}`;
            },
            searchItem() {
                if (!this.historyList) { return null; }
                for (const dateObj of this.historyList) {
                    for (const item of dateObj.list) {
                        if (item.conversation_id === this.curConversation_id) {
                            return item;
                        }
                    }
                }
                return null;
            },
            checkContinue() {
                var continueInfo = localStorage.getItem('continue');
                console.log(continueInfo);
                if (continueInfo) {
                    try {
                        var continueObj = JSON.parse(continueInfo);
                        console.log(continueObj);
                        if (continueObj.conversation_id && continueObj.userid) {
                            this.curConversation_id = continueObj.conversation_id;
                            this.curUserId = continueObj.userid;
                            this.getConversationInfo(continueObj.conversation_id, continueObj.userid);
                            const item = this.searchItem();
                            console.log(item);
                            if (item) {
                                this.contentList = item.queryHistory;
                                this.answerTitle = item.tipInfo;
                                this.curSumStatus = item.summary ? true : false;
                                if (item.summary) {
                                    this.curSummary_id = item.summary;
                                }
                            }
                        }
                    } catch (e) {
                        console.log("parse continue error");
                        console.log(e);
                    }
                }
            },
            parseParams() {
                if (localStorage.getItem('character')) {
                    this.curChatCharacter = JSON.parse(localStorage.getItem('character'));
                }
                console.log("sdadasds-----------");
                console.log(this.curChatCharacter);
                
                this.welcome.title = "训练模型·" + this.curChatCharacter.name;
                this.welcome.desc = this.curChatCharacter.description;
                this.welcome.icon = this.getAvatar(this.curChatCharacter);
                this.curUserId = "user_";
                const token = localStorage.getItem('token');
                if (token) {
                    const decodedToken = jwtDecode(token);
                    this.curUserId += decodedToken.user_id;
                }
                this.curSummary_id = this.curChatCharacter.client_ID
                    console.log("this.curSummary_id");
                console.log(this.curSummary_id);
            },
            backToList() {
                this.$router.push({ name: 'SimulationList' })
            },

            // 添加新的方法处理重命名和删除
            renameHistory() {
                // 实现重命名逻辑
                console.log('Rename history');
            },
            deleteHistory() {
                // 实现删除逻辑
                console.log('Delete history');
            },

            selectShowHistory(id1, id2) {
                console.log(this.historyList);
                console.log([id1, id2]);
                this.curHistoryIndex = [id1, id2];
                const talkitem = this.historyList[id1].list[id2];
                this.getConversationInfo(talkitem.conversation_id, this.curUserId);
                this.contentList = this.historyList[id1].list[id2].queryHistory;
                this.answerTitle = this.historyList[id1].list[id2].tipInfo;
                this.curConversation_id = this.historyList[id1].list[id2].conversation_id;
                this.curSumStatus = this.historyList[id1].list[id2].summary ?true:false;

                if (this.historyList[id1].list[id2].summary) {
                    this.curSummary_id = this.historyList[id1].list[id2].summary;
                }else if (this.globalCharacters && this.historyList[id1].list[id2].characterId) {
                    console.log("========1=========");
                    console.log(this.globalCharacters);
                    console.log(this.historyList[id1].list[id2]);
                    const targetObject = this.globalCharacters.find(item => item.id === this.historyList[id1].list[id2].characterId);
                    console.log(targetObject);
                    this.curSummary_id =targetObject.client_ID
                } else {
                    console.log("error!1");
                }
            },
            toggleDropdown(index, index2) {
                this.curSelectIndex = [index, index2];
                const prestate = this.historyList[index].list[index2].showMore;

                // 关闭所有其他的下拉菜单
                for (var histories of this.historyList) {
                    for (var item of histories.list) {
                        item.showMore = false;
                    }
                }

                if (!prestate) {
                    // 获取点击的省略号图标元素
                    const ellipsisIcon = event.target;
                    const rect = ellipsisIcon.getBoundingClientRect();

                    // 计算下拉菜单的位置
                    this.dropdownPosition = {
                        top: rect.bottom + window.scrollY,
                        left: rect.left + window.scrollX
                    };

                    this.historyList[index].list[index2].showMore = true;
                }
            },
            handleClickOutside(event) {
                   if (this.historyList[this.curSelectIndex[0]]&& 
                        this.historyList[this.curSelectIndex[0]].list[this.curSelectIndex[1]] && this.historyList[this.curSelectIndex[0]].list[this.curSelectIndex[1]].showMore) {
                        const isMenu = event.target.closest(".action-menu");
                        console.log("isMenu");
                        if (!isMenu) {
                            for(var histrories of this.historyList){
                                 for (var item of histrories.list) {
                                     item.showMore = false;
                                 }
                            }
                        }
                   } else {
                        return;
                   }
            },
            toggleSidebar(event) {
                  event.preventDefault();
                  console.log("dsfd");
                this.isExpanded = !this.isExpanded;
                if (this.isExpanded) {
                    this.getHistoryTalk();
                }
            },
            getTalkDetail() {
              /*chat.historyDetail({
                  uuid: this.activeChat
                })
                .then((res) => {
                  this.contentList = []
                  if (res.code == 0) {
                    res.info.history_meta &&
                      res.info.history_meta.forEach((item, index) => {
                        if (item.conversation_type == 'Answer') {
                          // 增加一个历史思考记录收起吧
                          item.context = item.context
                            .replace(/<think>\n\n<\/think>/g, '')
                            .replaceAll(
                              '<think>',
                              `<div class="think-time">历史思考<i id="think_icon_${index}" onclick="hiddenThink(${index})" class="ec-font icon-a-xiangxia3"></i></div><section id="think_content_${index}">`
                            )
                            .replaceAll('</think>', '</section>')
                          item.context = this.markdownIt.render(item.context)
                        }

                        this.contentList.push({
                          type: item.conversation_type == 'Question' ? 'send' : 'answer',
                          message: item.context
                        })
                      })
                    this.answerTitle = res.info.name.substring(0, 20)
                  }
                })*/
            },
            enterMessage(event) {
              if (event.key === 'Enter' && !event.shiftKey) {
                event.preventDefault()
                this.sendMessage()
              }
            },
            sendMessage() {
                if(this.welcome.desc=='角色模型加载失败，请返回主页重新进入。'){
                    this.$message({message: '角色模型加载失败，请返回主页重新进入。',type: 'error'})
                    return;
                }
                // 终止当前对话
                if (this.isTalking) {
                    this.eventSourceChat && this.eventSourceChat.close()
                    // 关闭后,处理正在对话的"思考中"
                    let curAnswer = this.contentList[this.contentList.length - 1].message
                    curAnswer = curAnswer.replaceAll('<div class="think-time">思考中……</div>', '对话中止')
                    this.contentList[this.contentList.length - 1].message = curAnswer
                    this.isTalking = false // todo 说话过程发消息 异常显示
                    // 再获取一下历史记录
                    return
                }

                if (!this.inputMessage ||
                    this.inputMessage.trim() === '' ||
                    this.inputMessage.split(/\r?\n/).every((line) => line.trim() === '')) {
                    this.inputMessage = ''
                    return false
                }
                // 回到初始高度
                const textarea = this.$refs.input
                textarea.style.height = '56px'
                this.msgHight = '56px'
                this.eventSourceChat && this.eventSourceChat.close()
                // let markedText = this.markdownIt.render(this.inputMessage)
                this.contentList.push({ type: 'send', message: this.inputMessage })
                this.contentList.push({ type: 'answer', message: `<div class="think-time">思考中……</div>` })
                this.answerTitle = this.answerTitle || this.contentList[0].message.substring(0, 20)
                this.scrollToBottom()
                this.initSSEChat()
            },
            initSSEChat() {
                console.log("this.inputMessage");
                console.log(this.inputMessage);
           
                this.inputMessage = ''
                var buffer = ''
                var partDisplayBuf = ''
                this.startTime = null
                this.endTime = null
                this.thinkTime = null
                let len = this.contentList.length
                let index = len % 2 === 0 ? len - 1 : len
                this.isTalking = true

                var mycontent = `<div class="think-time">思考中……</div><section id="think_content_${index}"><think></think>`
                buffer = mycontent
                this.startTime = Math.floor(new Date().getTime() / 1000)
                var markedText = this.markdownIt.render(buffer)
                this.contentList[index] = { type: 'answer', message: markedText }
                this.scrollToBottomIfAtBottom()

                

                console.log("message");
                console.log(this.contentList[this.contentList.length - 2].message);
                this.curConversation_id = null;//防止获取失败，导致不为空
            const sendRequest = async() => {
                try {
                    await fetchEventSource("/xing-api/v1/chat-messages", {
                        method: 'POST',
                        headers: {
                            "Authorization": `Bearer ${this.curChatCharacter.api_key}`,
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            inputs: {},
                            query: this.contentList[this.contentList.length - 2].message,
                            response_mode: 'streaming',
                            conversation_id: this.curConversation_id,
                            user: this.curUserId

                        }),
                        onmessage: (event) => {
                            if (event.data) {
                                console.log("收到数据");
                                console.log(event.data);
                                var resData = JSON.parse(event.data);
                                console.log(resData.event);
                                switch (resData.event) {
                                    case "workflow_started"://后台收到了
                                        console.log("start event");
                                        this.ansDisplayBuffer="";
                                        break;
                                    case "node_started":
                                        console.log("get conversation id");
                                        console.log(resData.conversation_id);
                                        console.log(this.curConversation_id);
                                        if (this.curConversation_id != resData.conversation_id) {
                                            this.curConversation_id = resData.conversation_id;
                                            this.updateConversation();
                                        }
                                        break;
                                    case "message":/*
                                        console.log("ans info");
                                        console.log(resData.answer);*/
                                        this.ansDisplayBuffer=this.ansDisplayBuffer+resData.answer;
                                            if(!this.typingInterval){
                                                this.typingInterval= setInterval(() => {
                                                    if (partDisplayBuf.length < this.ansDisplayBuffer.length) {
                                                        const remaining = this.ansDisplayBuffer.length - partDisplayBuf.length
                                                        const addChars = this.ansDisplayBuffer.substr(partDisplayBuf.length, Math.min(3, remaining))
                                                        partDisplayBuf += addChars;
                                                        /*console.log("partDisplayBuf");
                                                        console.log(partDisplayBuf);*/
                                                        let markedText = this.markdownIt.render(partDisplayBuf)
                                                        /*console.log("markedText");
                                                        console.log(markedText);*/
                                                        this.contentList.splice(index, 1, { type: 'answer', message: markedText });
                                                        this.scrollToBottomIfAtBottom();
                                                    } else {
                                                        clearInterval(this.typingInterval)
                                                        this.typingInterval = null
                                                    }
                                                }, 40);
                                            }
                                        break;
                                    case "message_end"://end
                                        console.log("finish!");
                                        this.isTalking = false;
                                        break;

                                }
                            }
                        },
                        onopen: (response) => {
                            console.log("onopen");
                            console.log(response.status);

                            if (response.status >= 400) {
                                throw new Error(`HTTP error ! status: $ {
                                    response.status
                                }`);
                            }
                        },
                        onerror: (error) => {
                            console.error('请求出错:');
                            console.error(error);
                            throw error;
                        }
                    });
                } catch(error) {
                    console.error('发生错误:');
                    console.error(error);
                    this.isTalking = false;
                }
            };
            sendRequest()

            },
            sleep(ms) {
              return new Promise((resolve) => setTimeout(resolve, ms))
            },
            scrollToBottomIfAtBottom() {
              this.$nextTick(() => {
                const logContainer = this.$refs.logContainer
                if (logContainer) {

            
                  const threshold = 100
                  const distanceToBottom = logContainer.scrollHeight - logContainer.scrollTop - logContainer.clientHeight

                  console.log( logContainer.scrollHeight );
                  console.log( logContainer.scrollTop);
                  console.log(logContainer.clientHeight);
                  if (distanceToBottom <= threshold) logContainer.scrollTop = logContainer.scrollHeight
                }
              })
            },
            scrollToBottom() {
              this.$nextTick(() => {
                const logContainer = this.$refs.logContainer
                if (logContainer) {
                  logContainer.scrollTop = logContainer.scrollHeight
                }
              })
            },
            clearWindow() {
              this.eventSourceChat && this.eventSourceChat.close()
              this.contentList = []
              this.answerTitle = ''
              this.talkUUID = ''
              this.inputMessage = ''
              this.refreshHistoryFlag = false
              this.isTalking = false
              const textarea = this.$refs.input
              textarea.style.height = '56px'
              this.msgHight = '56px'
              this.curConversation_id = null;
            },
            newChat() {
              this.clearWindow()
            },
            adjustInputHeight(event) {
              // enter键盘按下的换行赋值为空
              if (event.key === 'Enter' && !event.shiftKey) {
                this.inputMessage = ''
                event.preventDefault()
                return
              }

              this.$nextTick(() => {
                const textarea = this.$refs.input
                textarea.style.height = 'auto'
                // 最高200px
                textarea.style.height = Math.min(textarea.scrollHeight, 200) + 'px'
                this.msgHight = textarea.style.height
              })
            },
            copyMsg(txt) {
              // 复制功能
              // 创建一个临时的 textarea 元素
              const textarea = document.createElement('textarea')
              textarea.value = txt.replace(/<[^>]+>/g, '') // 去掉html标签
              textarea.style.position = 'fixed'
              document.body.appendChild(textarea)
              textarea.select() // 选中文本

              try {
                document.execCommand('copy') // 执行复制
                this.$message({
                  message: '复制成功',
                  type: 'success'
                })
              } catch (err) {
                  this.$message({
                      message: '复制失败',
                      type: 'error'
                  })
              } finally {
                document.body.removeChild(textarea) // 移除临时元素
              }
              },
            formatDayInfo(inDate) {
            const inputDate = new Date(inDate);
            const today = new Date();
            const yesterday = new Date(today);
            yesterday.setDate(today.getDate() - 1);
            if (inputDate.getFullYear() === today.getFullYear() &&
                  inputDate.getMonth() === today.getMonth() &&
                  inputDate.getDate() === today.getDate()) {
                return "今天";
            }
            else if (inputDate.getFullYear() === yesterday.getFullYear() &&
                  inputDate.getMonth() === yesterday.getMonth() &&
                  inputDate.getDate() === yesterday.getDate()) {
                return "昨天";
            } else {
                return inDate;
            }
        }
        },
    created() {
        if (!this.globalCharacters) { this.fetchCharacters(); }        
        this.parseParams();
        this.getHistoryTalk();
        this.checkContinue();
    },
    beforeDestroy() {
        // 移除窗口大小变化监听器
        window.removeEventListener('resize', this.checkScreenSize);
        // 关闭事件源
        this.eventSourceChat && this.eventSourceChat.close()
        // 移除点击事件监听器
        document.removeEventListener("click", this.handleClickOutside);
    }
}
</script>

<style >
    @import url('https: //cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css');
    .chat-sidebar{
        width: 70px; /* 初始宽度，可以根据需要调整 */
        transition: width 0.3s ease-in-out; /* 宽度过渡效果 */
    }

    .sidebar-expanded {
        width: 250px; /* 展开后的宽度，可以根据需要调整 */
    }
</style>
<style scoped lang="scss">
/* 通用样式 */
.talk-window {
  height: 100%;
  transition: margin 0.2s ease;
  position: relative;
}

/* 移动端样式 */
.mobile-sidebar {
  transition: all 0.3s ease;
  height: 100vh;
  overflow-y: auto;
}
.talk-container {
  height: calc(100vh - 58px);
  position: relative;
}
.talk-welcome {
  text-align: center;
  // margin-bottom: 25px;
  padding: 10% 20% 25px;
  box-sizing: border-box;
  h1 {
    margin-bottom: 30px;
    font-size: 21px;
  }
  p {
    color: #8f9aad;
  }
}
.messages {
  padding: 20px;
  overflow-y: auto;
}

.message {
  display: flex;
  margin: 12px 0;
}

.message.user {
  justify-content: flex-end;
}

.bubble {
  max-width: 70%;
  padding: 12px 16px;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.message.user .bubble {
  background: #e8f4ff;
}

.time {
  font-size: 12px;
  color: #666;
  margin-top: 4px;
}

.talk-send {
  background: #f1f2f7;
  border-radius: 10px;
  border: 1px solid #e9e9eb;
  padding: 5px 10px;

  margin: 0px 20%;
  img {
    cursor: pointer;
  }

  textarea {
    width: 100%;
    padding: 10px;
    resize: none;
    overflow: auto;
    max-height: 200px;
    line-height: 1.5;
    box-sizing: border-box;
    font-family: inherit;
    border: 0px;
    background: #f1f2f7;
  }
  textarea:focus {
    outline: none !important;
  }
}

input {
  flex: 1;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 8px;
}

.talk-title {
  height: 56px;
  line-height: 56px;
  p {
    color: #000000;
    font-size: 15px;
    font-weight: 550;
    text-align: center;
  }
  .sangedianBtn {
    width: 225px;
    height: 32px;
    position: absolute;
    top: 15px;
    right: 30px;
  }
}

.send-item {
  max-width: 60%;
  word-break: break-all;
  padding: 10px;
  background: #eef6ff;
  border-radius: 10px;
  color: #000000;
  white-space: pre-wrap;
  font-size: 13px;
}
.msg-row {
  margin-bottom: 10px;
}
    .talk-box {
        height: calc(100% - 140px);

        .talk-content {
            /*background-color: #fff;*/
            color: #324659;
            overflow-y: auto;
            height: calc(100% - 50px);
            box-sizing: border-box;
            padding: 0px 20%;
            //padding: 0px 6%; /* 减少内边距，使对话气泡更靠近屏幕边缘 */
            // &:hover {
            //   overflow-y: auto;
            // }
            .chat-assistant {
                display: flex;
                margin-bottom: 10px;

                .answer-item {
                    line-height: 30px;
                    color: #324659;
                }
            }

            .answer-cont {
                position: relative;
                display: flex;
                width: 100%;

                > img {
                    width: 30px;
                    height: 30px;
                    margin-right: 10px;
                }

                &.end {
                    justify-content: flex-end;
                    //padding-right: 0; /* 减少右侧边距，使对话气泡更靠近右侧边缘 */
                }

                &.start {
                    justify-content: flex-start;
                   // padding-left: 0; /* 减少左侧边距，使对话气泡更靠近左侧边缘 */
                }
            }
        }

        .chat-sse {
            min-height: 100px;
            max-height: 460px;
        }

        .chat-message {
            height: calc(100vh - 276px);
        }

        .thinking-bubble {
            height: calc(100vh - 296px);
        }
    }
.chat-add {
  width: 111px;
  height: 33px;
  background: #dbeafe;
  border-radius: 6px !important;
  font-size: 14px !important;
  border: 0px;
  color: #516ffe !important;
  &:hover {
    background: #ebf0f7;
  }
  .icon-tianjia1 {
    margin-right: 10px;
    font-size: 14px;
  }
}
.talk-btn-cont {
  text-align: right;
  height: 30px;
  margin-top: 5px;
}
    .chat-sidebar {
        transition: all 0.3s ease;
    }

    svg:hover {
        transform: scale(1.1);
        transition: transform 0.2s ease;
    }
    .hover-scale {
        transition: transform 0.2s ease;
    }
    .hover-scale:hover {
        transform: scale(1.1);
    }

    .action-menu {
        z-index: 9999;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    }

    /* 添加过渡效果 */
    .action-menu {
        transition: opacity 0.2s ease;
    }
        .character-info {
            max-width: 180px;
            background-color: rgba(255, 255, 255, 0.95);
            backdrop-filter: blur(5px);
            border: 1px solid rgba(229, 231, 235, 0.8);
        }
        /* 确保下拉菜单项有正确的交互效果 */
        .action-menu a {
            transition: background-color 0.2s ease;
        }
        
        /* 移动端特定样式 */
        @media (max-width: 767px) {
            .talk-box .talk-content {
                padding: 0 6%;
            }
            .talk-send {
                margin: 0;
                padding: 8px;
                box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
            }
            
            .talk-send textarea {
                min-height: 40px;
                max-height: 100px;
                padding: 8px;
                border-radius: 18px;
                background-color: #f8f9fa;
                border: 1px solid #e9ecef;
            }
            
            .talk-content {
                padding: 0 2%; /* 减少内边距，使对话气泡更靠近屏幕边缘 */
                margin-bottom: 60px; /* 为固定在底部的输入框留出空间 */
            }
            
            .send-item, .answer-item {
                font-size: 14px;
                padding: 8px 12px;
                max-width: 90%; /* 增加最大宽度，使对话气泡更宽 */
                border-radius: 18px;
            }
            
            .send-item {
                background-color: #e3f2fd;
                margin-right: 0; /* 使发送的消息更靠近右侧边缘 */
            }
            
            .answer-item {
                background-color: #f5f5f5;
                margin-left: 0; /* 使接收的消息更靠近左侧边缘 */
            }
            
            .answer-cont.end {
                padding-right: 0; /* 确保在移动端也减少右侧边距 */
            }
            
            .answer-cont.start {
                padding-left: 0; /* 确保在移动端也减少左侧边距 */
            }
            
            .talk-title {
                height: 48px;
                line-height: 48px;
                box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
                background-color: #ffffff;
                position: sticky;
                top: 0;
                z-index: 10;
            }
            
            .talk-welcome {
                padding: 10% 10% 20px;
            }
            
            .talk-welcome h1 {
                font-size: 18px;
            }
            
            .talk-welcome p {
                font-size: 14px;
            }
            
            .character-info {
                max-width: 80%;
                margin: 0 auto;
                box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
                border-radius: 12px;
            }
            
            .talk-box {
                padding-bottom: 60px; /* 为固定在底部的输入框留出空间 */
            }
        }
</style>
